import React, { useCallback } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { TeamSelectList } from "widgets/src/TeamSelectList";
import { useModalInsets } from "../../components/mobile/useModalInsets";
import { RoutineEditScreenProps } from "./RoutineEditMain/RoutineEditNavigation";
import { RoutineEditOwnerTeamQuery } from "./__generated__/RoutineEditOwnerTeamQuery.graphql";
import {
  useRoutineEditState,
  useRoutineEditStateSetParams,
} from "./State/RoutineEditState";
import { useNavigationHeader } from "@/src/common/navigationHeaderOptions";

export function RoutineEditOwnerTeam(
  props: RoutineEditScreenProps<"RoutineEditOwnerTeam">
) {
  const params = useRoutineEditState();

  useNavigationHeader({
    type: "DONE",
    onDone: () => {
      props.navigation.goBack();
    },
    title: params.title,
  });

  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => (
        <InnerRoutineEditOwnerTeam {...props} fetchKey={fetchKey} />
      )}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerRoutineEditOwnerTeam(props: { fetchKey: string }) {
  const setParams = useRoutineEditStateSetParams();
  const params = useRoutineEditState();
  const data = useLazyLoadQuery<RoutineEditOwnerTeamQuery>(
    graphql`
      query RoutineEditOwnerTeamQuery {
        storeViewer @required(action: THROW) {
          teams {
            ...TeamSelectList_Team
            id
            color
            name
            icon
            isPrivate
          }
        }
      }
    `,
    {},
    { fetchPolicy: "store-and-network", fetchKey: props.fetchKey }
  );
  const insets = useModalInsets();
  const setTeam = useCallback(
    (teamId: string) => {
      const team = data.storeViewer.teams.find(({ id }) => id === teamId);
      if (team) {
        // Clear assigned roles when team changes since roles are team-specific
        setParams({ team, assignedRoleIds: [] });
      }
    },
    [data.storeViewer.teams, setParams]
  );

  return (
    <TeamSelectList
      selected={params.team?.id ? [params.team.id] : []}
      insets={insets}
      onItemPress={setTeam}
      teams={data.storeViewer.teams}
      contentBox={{ spaceTop: "medium" }}
    />
  );
}
